import Marquee from "react-fast-marquee";

export const Footer = ({ onEnter }) => {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-background border-t border-white/10 pt-16 md:pt-24 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 md:pb-24">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-blood animate-flicker" />
              <span className="font-mono text-xs tracking-[0.35em] uppercase text-bone">
                Old Geezer
              </span>
            </div>
            <p className="mt-6 max-w-sm text-sm text-muted-foreground leading-relaxed">
              A streaming archive of horror & science-fiction classics that
              belong to the public domain — restored, curated, and yours for
              two dollars a month.
            </p>
            <button
              data-testid="footer-enter-btn"
              onClick={onEnter}
              className="mt-8 inline-flex items-center gap-2 border border-white/20 hover:border-blood hover:bg-blood px-6 py-3 font-mono text-[11px] tracking-[0.25em] uppercase transition-all duration-300"
            >
              Enter the Vault
            </button>

            <div data-testid="footer-contact" className="mt-10">
              <h4 className="font-mono text-[10px] tracking-[0.3em] uppercase text-blood mb-4">
                Contact
              </h4>
              <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-bone">
                Daniel Turner
              </p>
              <a
                data-testid="footer-contact-email"
                href="mailto:danielturner1974may@gmail.com"
                className="mt-1 inline-block text-sm text-muted-foreground hover:text-bone transition-colors lowercase"
              >
                danielturner1974may@gmail.com
              </a>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {[
              { h: "Browse", items: ["Horror", "Sci-Fi", "New Restorations", "Full Archive"] },
              { h: "About", items: ["The Manifesto", "Public Domain", "Preservation", "Press"] },
              { h: "Connect", items: ["Newsletter", "Instagram", "Letterboxd", "Contact"] },
            ].map((col) => (
              <div key={col.h}>
                <h4 className="font-mono text-[10px] tracking-[0.3em] uppercase text-blood mb-5">
                  {col.h}
                </h4>
                <ul className="space-y-3">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a
                        href={it === "Contact" ? "mailto:danielturner1974may@gmail.com" : "#pricing"}
                        className="text-sm text-muted-foreground hover:text-bone transition-colors"
                      >
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Massive wordmark marquee */}
      <div className="border-t border-white/10 py-6 md:py-10">
        <Marquee speed={30} gradient={false} autoFill>
          <span className="font-serif text-[16vw] md:text-[13vw] leading-none tracking-tighter text-bone/90 px-8">
            OLD GEEZER
          </span>
          <span className="font-serif italic text-[16vw] md:text-[13vw] leading-none tracking-tighter text-blood px-8">
            *
          </span>
        </Marquee>
      </div>

      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
          © {new Date().getFullYear()} Old Geezer — All films in the public domain
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
          Made after dark
        </p>
      </div>
    </footer>
  );
};
